import { Link } from '@cian/ui-kit';
import { IconFinanceChart16 } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';

type TProps = {
  href: string;
  rating?: number;
  onClick: () => void;
};

export const ContentRating: React.FC<TProps> = ({ href, rating, onClick }) => {
  const buttonText = rating ? `Рейтинг: ${rating}` : 'Рейтинг';

  return (
    <Link
      href={href}
      target="_blank"
      color="current_color"
      fontWeight="bold"
      beforeIcon={<IconFinanceChart16 />}
      onClick={onClick}
    >
      {buttonText}
    </Link>
  );
};
